export const isApiErrorResponse = <T>(response: unknown, fields: (keyof T)[]): boolean => {
  if (!response || typeof response !== 'object') {
    return false;
  }

  const dataResponse = response as { data: Partial<T> };

  if (!dataResponse.hasOwnProperty('data')) {
    return false;
  }

  const { data } = dataResponse;

  for (const field of fields) {
    if (!data.hasOwnProperty(field)) {
      return false;
    }
  }

  return true;
};

export const isNetworkErrorResponse = (response: unknown): response is Error => {
  if (!response || typeof response !== 'object') {
    return false;
  }

  return response.hasOwnProperty('name') && response.hasOwnProperty('message');
};
